// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.genius-button.enlarge-on-hover:hover {
  background-color: transparent;
  color: white;
  font-size: 15px;
}

button.genius-button,
button.genius-button:focus,
button.genius-button:hover,
button.genius-button:active,
button.genius-button:active:focus {
  background-color: transparent;
  border: none;
  color: white;
  padding: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/genius_button/index.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;;EAKE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,aAAa;AACf","sourcesContent":["button.genius-button.enlarge-on-hover:hover {\n  background-color: transparent;\n  color: white;\n  font-size: 15px;\n}\n\nbutton.genius-button,\nbutton.genius-button:focus,\nbutton.genius-button:hover,\nbutton.genius-button:active,\nbutton.genius-button:active:focus {\n  background-color: transparent;\n  border: none;\n  color: white;\n  padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
